import React from "react";
import UserMessage from "./UserMessage";
import AssistantMessage from "./AssistantMessage";

export default function Message({
  message,
  children,
}) {
  if (!message) return null;

  const role = message.role || "assistant";

  if (role === "user") {
    return (
      <UserMessage
        content={message.content}
        timestamp={message.createdAt || message.timestamp}
      />
    );
  }

  return (
    <AssistantMessage
      content={message.content}
      timestamp={message.createdAt || message.timestamp}
    >
      {children}
    </AssistantMessage>
  );
}